/**
 * @file PastEvents 组件
 * @author yuanyaojia@baijia.com
 * @date 2021-04-21
 */

import React, {useEffect} from 'react';
import {useHistory} from 'react-router-dom';
import {Row, Col, Tabs, Spin} from 'antd';
import moment from 'moment';
import BaseCard from '~/component/BaseCard';
import Item from './Item';

import './index.less';

function PastEvents({data: {contentResponseList}}) {
    const history = useHistory();
    const dataList = contentResponseList?.slice(0, 4);

    function handleDetail(uid) {
        history.push(`/news/detail/${uid}`);
    }

    function handleClick() {
        history.push('/news/events');
    }

    return (
        <div className="past-container">
            <BaseCard title="Past Events" onClick={handleClick} isConfig>
                <Row>
                    {!!dataList
                        && dataList.map(({uid, content: {title, date, time, timeZone}}) => (
                            // eslint-disable-next-line
                            <Col span={12} onClick={() => handleDetail(uid)} >
                                <Item
                                    title={title}
                                    time={`${`${date} ${time}`} ${timeZone}`}
                                />
                            </Col>
                        ))}
                </Row>
            </BaseCard>
        </div>
    );
}

export default PastEvents;
